import { RedirectMechanismType, TrackingQueryStringKey, TravelCurrencyCode } from '@graphql/generated';

export enum PartnerHotelIdType {
  hotels = 'hotels',
  joy = 'joy',
  stays = 'stays'
}

export enum PartnerSourceIdType {
  hotels = 'zh',
  joy = 'joyPlace',
  stays = 'nuitee'
}

export enum PartnerHotelDetailsRouteQueryParams {
  discountCode = 'discountCode',
  eventId = 'eventId',
  idType = 'idType',
  joyPlaceId = 'joyPlaceId',
  source = 'source',
  utm_campaign = 'utm_campaign',
  utm_medium = 'utm_medium',
  utm_source = 'utm_source',
  utm_source_secondary = 'utm_source_secondary'
}

export interface RedirectMechanismProps {
  __typename?: 'RedirectMechanism';
  telemetryDestinationName: string;
  trackingQueryStringKey?: TrackingQueryStringKey | null;
  type: RedirectMechanismType;
  url: string;
}

export interface GoogleMapsProps {
  lat?: number | null;
  lng?: number | null;
  gplid?: string | null;
  name?: string | null;
  address?: string | null;
  zentrumHubId?: string | null;
}

export interface Pricing {
  currency: TravelCurrencyCode;
  digits: number;
  floatingPointDecimalString: string;
  valueInMinorUnits: number;
}
export interface PricingInfoProps {
  nightlyBaseRate: Pricing;
  strikeoutNightlyBaseRate?: Pricing | null;
}

export interface TravelPlaceProps {
  type: 'joyPlace' | 'accommodationPlace';
  id?: string | null;
  name?: string | null;
  url?: string | null;
  customUrl?: string | null;
}

export interface TelemetryHotelInfo {
  hotelName?: string | null;
  hotelPriceCurrency?: TravelCurrencyCode | null;
  hotelPrice?: string | null;
  hotelStrikeOutPrice?: string | null;
}

export interface GuestPartnerHotelBookingRedirectParams extends TelemetryHotelInfo {
  telemetryName?: string;
  hotelSearchPageUrlType?: 'hotelSoldOut' | 'hotelWebsite'; // Currently support only hotelSoldOut interceptor, we will support different types.
  redirectMechanismType?: RedirectMechanismType;
  clientReference?: string;
  destinationName?: string;
  destinationUrl?: URL;
  zentrumHub?: {
    id: string;
  };
  hotelWebsite?: {
    value: string;
  };
  googleMaps?: {
    gplid?: string;
    name?: string;
    address?: string;
    lat?: string;
    lng?: string;
  };
  source?: string | null;
  utm_source?: string | null;
  utm_source_secondary?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  redirectToSafeLink?: boolean;
  onTelemetrySend?: () => void;

  // For Joy room blocks
  roomBlockUrl?: URL;
  roomBlockSuccess?: boolean;
}
